import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { QuickLinksCustomizeIcon } from './dashboardQuickLinksHeader';

const CUSTOMIZE_HOME_LABEL = '自定义首页';

export const DashboardLayoutCustomizeTrigger = ({ onClick, className = '' }) => (
	<button type='button' className={classNames('dashboard-home-version-footer__customize-pill', className)} onClick={onClick}>
		<QuickLinksCustomizeIcon className='dashboard-home-version-footer__customize-pill-icon' aria-hidden='true' />
		<span className='dashboard-home-version-footer__customize-pill-label'>{CUSTOMIZE_HOME_LABEL}</span>
	</button>
);

DashboardLayoutCustomizeTrigger.propTypes = {
	onClick: PropTypes.func.isRequired,
	className: PropTypes.string,
};

const DashboardLayoutToolbar = ({ isResetting = false, onFinishEditing, onRestoreDefault }) => (
	<div className='dashboard-layout-toolbar dashboard-layout-toolbar--editing d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2'>
		<p className='dashboard-layout-toolbar__hint text-muted small mb-0'>拖拽区块标题调整顺序，点击眼睛图标显示或隐藏</p>
		<div className='dashboard-layout-toolbar__actions d-flex flex-wrap gap-2'>
			<Button type='button' size='sm' variant='outline-secondary' onClick={onRestoreDefault} disabled={isResetting}>
				{isResetting ? '恢复中…' : '恢复默认'}
			</Button>
			<Button type='button' size='sm' variant='primary' onClick={onFinishEditing}>
				完成
			</Button>
		</div>
	</div>
);

DashboardLayoutToolbar.propTypes = {
	isResetting: PropTypes.bool,
	onFinishEditing: PropTypes.func.isRequired,
	onRestoreDefault: PropTypes.func.isRequired,
};

export default DashboardLayoutToolbar;
